// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CertificateStatusUi-common {
    border-radius: 6px;
  
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    display: flex;
    align-items: center;
    height: 24px;
  }
  
  .NeedsInfo {
    width: 166px;
    color: #7A5C00;
    background: #FFF5D6;
  
  }
  
  .CertificateStatusIcon-common {
    vertical-align: middle;
    font-style: normal;
    font-weight: 400;
    margin-left: 4px;
    margin-right: 4px;
  }
  
  .NeedsInfoIcon {
    color: #7A5C00 !important;
    font-size: 15px;
  }
  
  
  .verified {
    width: 81px;
    background: #E0F5E6;
    color: #1F5C2E;
  }
  
  .verifiedIcon {
    color: #1F5C2E;
    font-size: 17px;
  }
  
  .underreview {
    background: #D8EBFD;
    width: 118px;
    color: #063E75
  }
  
  .underreviewIcon {
    color: #063E75;
    font-size: 18.5px;
  }

  .expired {
    background: #E7DFF7;
    width: 80px;
    color: #331A63;
  
  }
  
  .expiredIcon {
    color: #331A63;
    font-size: 17px;
  }`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/StatusBadge/StatusBadge.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,mBAAmB;;EAErB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;;EAGA;IACE,WAAW;IACX,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ;EACF;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,cAAc;;EAEhB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB","sourcesContent":[".CertificateStatusUi-common {\n    border-radius: 6px;\n  \n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    height: 24px;\n  }\n  \n  .NeedsInfo {\n    width: 166px;\n    color: #7A5C00;\n    background: #FFF5D6;\n  \n  }\n  \n  .CertificateStatusIcon-common {\n    vertical-align: middle;\n    font-style: normal;\n    font-weight: 400;\n    margin-left: 4px;\n    margin-right: 4px;\n  }\n  \n  .NeedsInfoIcon {\n    color: #7A5C00 !important;\n    font-size: 15px;\n  }\n  \n  \n  .verified {\n    width: 81px;\n    background: #E0F5E6;\n    color: #1F5C2E;\n  }\n  \n  .verifiedIcon {\n    color: #1F5C2E;\n    font-size: 17px;\n  }\n  \n  .underreview {\n    background: #D8EBFD;\n    width: 118px;\n    color: #063E75\n  }\n  \n  .underreviewIcon {\n    color: #063E75;\n    font-size: 18.5px;\n  }\n\n  .expired {\n    background: #E7DFF7;\n    width: 80px;\n    color: #331A63;\n  \n  }\n  \n  .expiredIcon {\n    color: #331A63;\n    font-size: 17px;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
